export const sortFields = [
	'takeOffType',
	'level',
	'material',
	'sku',
	'quantity',
	'uom',
	'usage',
	'imageName',
] as const;
